import React, { Component } from 'react';
import ReactCustomFlagSelect from './ReactCustomFlagSelect';
import { ToastContainer, toast } from 'react-toastify';
import LotDetails from './LotDetails';
import DateTimeModal from './DateTimeModal';
import 'react-toastify/dist/ReactToastify.css';
import { QrReader } from 'react-qr-reader';
import moment from 'moment';
import 'moment-timezone';
import { countryCode, getStripeError } from './static';
import './App.css';
import gpsIcon from "./img/gps.png";
import googleIcon from "./img/google-play.png";
import iosIcon from "./img/ios-appstore.png";
import notAllowed from "./img/exclamation-mark.png";
import cameraIcon from "./img/camera-qr.png";
import qrcode from "./img/qrcode.png";
import ErrorModal from './ErrorModal';

export default class App extends Component {

  constructor(props){
    super(props);
    this.initForm = this.initForm.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleAreaCode = this.handleAreaCode.bind(this);
    this.handleSpotChange = this.handleSpotChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.isAppleGooglePayButtonClicked = false;
    this.hours = [];
    this.mins = [];
    this.env = process.env.REACT_APP_ENVIRONMENT;
    this.isProd = this.env === "PROD";
    this.oversizeMsgLotList = [5742];
    this.logId = `${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    const urlParams = new URLSearchParams(window.location.search);
    this.isDev = urlParams.get('env') === 'dev';
    if(this.env === 'STAGING' && urlParams && urlParams.get('env') && this.isDev){
      this.baseUrl = process.env.REACT_APP_DEV_API_URL;
      this.stripeKey = process.env.REACT_APP_TEST_STRIPE_KEY;
    }else{
      this.baseUrl = process.env.REACT_APP_API_URL;
      this.stripeKey = process.env.REACT_APP_STRIPE_KEY;
    }
    this.restrictedLotOpening = this.env === "PROD" ? '' : 5720;
    this.fetchingGatedTime = null;
    this.fillHoursAndMinsOptions(0, 1440);
    this.initialState =  {
      parkingType:'',
      showWarning: false,
      isTimingDisabled: true,
      loading: false,
      isPaymentProcessing: false,
      booked: false,
      seeMore: false,
      isSaveProfile: true,
      discountAmount: 0,
      isPayment: true,
      fields: {
        areaCode: 1,
        hours: 0,
        mins: 0,
        email: ''
      },
      errors: {}
    }
    this.resetState = {
      parkingType: '',
      showWarning: false,
      booked: true,
      isTimingDisabled: true,
      isSaveProfile: true,
      bookingID: null,
      convenienceFee: null,
      end: null,
      errors: {},
      fields: {areaCode: 1, hours: 0, mins: 0, spot_no: '', email: '', license_plate: '', mobile: '', hours: '', mins: '', zip: '', cardholder_name: '', coupon: ''},
      loading: false,
      isPaymentProcessing: false,
      parkingFee: null,
      slotId: null,
      totalFee: null,
      couponApplied: false,
      discountAmount: 0,
      isPayment: true
    }
    this.state = this.initialState;
  }

  componentDidMount(){
    const defer = () =>  {
      if (window.Stripe) {
          this.initForm(this);
      } else {
          setTimeout(function() { defer ()  }, 50);
      }
    }
    this.refreshAfterSleep();
    defer();
  }

  fillHoursAndMinsOptions(minHour, maxMinutes, isOnlyHour) {
    this.hours = [];
    const maxDays = maxMinutes / 24;
  
    if (minHour <= 24) {
      for (let i = Math.ceil(minHour); i <= 24; i++) {
        this.hours.push({ value: i, display: `${i} Hr` });
      }
    }
 
    const fixedOptions = [36, 48];
    fixedOptions.forEach(opt => {
      if (opt >= minHour) {
        this.hours.push({ value: opt, display: `${opt} Hr` });
      }
    });

    for (let d = 3; d <= maxDays; d++) {
      const dayOption = d * 24;
      if (dayOption >= minHour) {
        this.hours.push({ value: dayOption, display: `${d} Days` });
      }
    }
    
    if (!isOnlyHour) {
      this.mins = [];
      for (let j = 0; j < 60; j += 5) {
        const display = j < 10 ? `0${j} mins` : `${j} mins`;
        this.mins.push({ value: j, display });
      }
    }
  }  

  fillHoursFromBackend(arr){
    this.hours = arr.filter(item => item.Hours && item.Hours.includes('-') && item.Hours.trim() !== "")
                    .map(item => {
                        const [startHour, endHour] = item.Hours.split('-').map(Number);
                        return { value: endHour, display: `${endHour} Hr` };
                  });
  }

  refreshAfterSleep(){
		var SAMPLE_RATE = 5000; 
		var lastSample = Date.now();
	  
		function refresh() {
		  if (Date.now() - lastSample >= SAMPLE_RATE * 2) {
			window.location.reload();
		  }
		  lastSample = Date.now();
		  setTimeout(refresh, SAMPLE_RATE);
		}
		refresh();
	}

  manageBodyBackground(isShow){
    if(isShow){
      document.querySelector('#root').classList.add('dark');
    }else{
      document.querySelector('#root').classList.remove('dark');
    }
  }

  handleEventTypePricing(data){
    this.fillHoursFromBackend(data.pricing)
  }

  checkIfManualStartTime = (data) => {
    let result = false;
    if(data?.gated_camera){
      result = true;
    }
    return result;
  }

  getHoursAndMinutes = (floatHours) => {
    if(!floatHours) return { hours: 0, mins: 0 };
    let hours = Math.floor(floatHours);
    const rawMinutes = (floatHours - hours) * 60;
    let mins = Math.ceil(rawMinutes / 5) * 5;
    if (mins === 60) {
      hours += 1;
      mins = 0;
    }
    return { hours, mins };
  }

  getArena(){
    const urlParams = new URLSearchParams(window.location.search);
    if(!urlParams.get('id')){
      this.setState({
        isInvalidURL: true,
      })
      return;
    }
    fetch(`${this.baseUrl}/pay/arena/details?arena_hash=${urlParams.get('id')}&web_log_id=${this.logId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
            const start = moment().format('MMM DD, YYYY, hh:mm A');
            const isShowOversizeMsg = this.oversizeMsgLotList.includes(resp.data.parking_id);
            const data = resp.data;
            const isTypeEvent = data.type == 'event_pricing';
            const isQRScanLot = data.parking_id == 5693;
            const isManualStartTime = this.checkIfManualStartTime(data); 
            const coupon = urlParams.get('coupon');
            const { hours, mins } = this.getHoursAndMinutes(data.default_hour);
            if(isTypeEvent){
              this.handleEventTypePricing(data);
            }
            this.setState({ 
              arenaDetails: data && data.pricing ? data : null, 
              parkingId: data.parking_id,
              name: data.name,
              start: start,
              isGatedCamera: data.gated_camera,
              end: moment(start, 'MMM DD, YYYY, hh:mm A').add(hours, 'hours').add(mins, 'minutes').format('MMM DD, YYYY, hh:mm A'),
              fields: {
                ...this.state.fields,
                hours,
                mins,
                coupon: coupon ? coupon : ''
              },
              isURLCoupon: coupon ? true : false,
              isWithSlot: data.with_slots ? true : false,
              fixedSlotId: data.with_slots ? '' : data.slot_id,
              parkingFee: data.parking_fee,
              convenienceFee: data.convenience_fee,
              totalFee: data.parking_charge,
              surchargeFee: data.surcharge_fee,
              salesTaxFee: data.sales_tax_fee,
              surchargeFeeTitle: data.custom_surcharge_tax_field_name,
              salesTaxFeeTitle: data.custom_sales_tax_field_name,
              transactionFee: data.additional_transaction_fee,
              timeZone: data.timezone,
              isShowOversizeMsg,
              isTypeEvent,
              lotPricing: data.pricing || [],
              isQRScanLot,
              isManualStartTime,
              isPayment: data.parking_charge > 0 ? true : false
            }, () => {
              if(this.state.fields.coupon){
                this.validateCoupon(true);
              }
            })
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.dismiss();
            toast.error(errMsg);
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  handleAfterArenaDetail(){
    if(false && this.state.parkingId == this.restrictedLotOpening){
      const isInvalid = this.isCurrentTimeBetween6AMAnd6PM();
      if(isInvalid) this.setState({showErrorModal: true})
    }
  }

  isCurrentTimeBetween6AMAnd6PM(){
    const timezone = this.state.timeZone;
    const currentTime = moment().tz(timezone);
    const startTime = moment().tz(timezone).set({ hour: 6, minute: 0, second: 0, millisecond: 0 });
    const endTime = moment().tz(timezone).set({ hour: 18, minute: 0, second: 0, millisecond: 0 });
  
    return currentTime.isBetween(startTime, endTime, null, '[]');
  }

  handleGatedContactNumberFocus(){
    if(this.state.isGatedCamera && !this.state.isStartTimeForGatedCalled && this.state.fields.license_plate){
      this.getStartTimeForGatedAndVehicleCategory();
    }else{
      this.getStartTimeForGatedAndVehicleCategory(true);
    }
  }

  handleDateTimeModal = (value, resetLicensePlate) => {
    this.setState({
      showDateTimeModal: value,
      fields: {
        ...this.state.fields,
        license_plate: !value && resetLicensePlate ? '' : this.state.fields.license_plate
      }
    });
  }

  getVehicleCategory = (data) => {
    const categoryList = [ "vip", "employee", "vendor"];
    let category = '';
    if(data?.is_monthly){
      category = 'monthly';
    }else if(data?.global_vip){
      category = 'global vip';
    }else if(data?.category && categoryList.includes(data?.category)){
      category = data.category;
    }
    return category;
  } 

  safeJson = url =>
    fetch(url)
      .then(r => r.ok ? r.json() : Promise.resolve({}))  
      .catch((e) => { /* console.log(e) */ } )   

  getStartTimeForGatedAndVehicleCategory(onlyCategory) {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const { parkingId, fields, isManualStartTime } = this.state;
    const vehicleNo = fields?.license_plate?.toUpperCase();
    if (!parkingId || !vehicleNo) return;
  
    const params = `?parking_id=${parkingId}&vehicle_no=${vehicleNo}&web_log_id=${this.logId}`;
    const startTimeUrl = `${this.baseUrl}/gated/booking/start/time${params}`;
    const categoryUrl  = `${this.baseUrl}/existing/customer/check${params}`;
  
    if (onlyCategory) {
      fetch(categoryUrl)
        .then(r => r.json())
        .then(resp => {
          if (resp.status === 'SUCCESS' && resp.data) {
            const vehicleCategory = this.getVehicleCategory(resp.data);
            this.setState({ vehicleCategory, showOverlay: vehicleCategory ? true : false });
          } else {
            const err = resp.error?.reason || 'Cannot get vehicle category';
            toast.dismiss(); 
            // toast.error(err);
          }
        })
        .catch(() => {
          toast.dismiss(); 
          // toast.error('Cannot get vehicle category');
        });
      return;
    }
  
    this.fetchingGatedTime = true;
    Promise.all([
      this.safeJson(startTimeUrl),
      this.safeJson(categoryUrl)
    ])
    .then(([startTimeResp, categoryResp]) => {
    const updates = {};

    if (categoryResp.status === 'SUCCESS' && categoryResp.data) {
      const vehicleCategory = this.getVehicleCategory(categoryResp.data);
      updates.vehicleCategory = vehicleCategory;
      if(vehicleCategory){
        this.setState({vehicleCategory, showOverlay: true});
        return;
      }
    } else {
      const err = categoryResp.error?.reason || 'Cannot get vehicle category';
      toast.dismiss(); 
      // toast.error(err);
    }

    if (startTimeResp.status === 'SUCCESS' && startTimeResp.data) {
      const data = startTimeResp.data;
      if (isManualStartTime && typeof data === 'object' && Object.keys(data).length === 0) {
        this.setState({...updates,
          showDateTimeModal: true,
          isStartTimeEmpty: true,
          start: null,
        });
        return;
      }
      updates.isStartTimeEmpty = false;
    } else {
      const err = startTimeResp.error?.reason || 'Cannot get booking start time';
      toast.dismiss(); 
      toast.error(err);
      this.setState({
        ...updates
      });
      return;
    }

    this.setState(updates, () => {
      this.handleStartTimeForGated(startTimeResp.data, true, true);
    });
  })
  .finally(() => {
    this.fetchingGatedTime = null;
  });

  }  

  handleStartTimeForGated = (data, isStartTimeUpdated, isGatedTimeFetched) => {
    const startTime = data.booking_start_time_str ? data.booking_start_time_str : moment().format('MMM DD, YYYY, hh:mm A');
    let endTime =  startTime ? moment(startTime, 'MMM DD, YYYY, hh:mm A').add(this.state.fields.hours, 'hours').format('MMM DD, YYYY, hh:mm A') : '';
    const isCallValidateCoupon = this.state.isURLCoupon && this.state.couponApplied;
    let dateTimeDiff, hours, mins;
    if((endTime && moment(endTime, 'MMM DD, YYYY, hh:mm A').isBefore(moment())) || isStartTimeUpdated){
      const currentTime = moment().format('MMM DD, YYYY, hh:mm A');
      dateTimeDiff = moment(currentTime, 'MMM DD, YYYY, hh:mm A').diff(startTime, 'hours', true);
      const duration = moment.duration(dateTimeDiff, 'hours');
      hours = Math.floor(duration.asHours());
      mins = Math.ceil(duration.minutes() / 5) * 5;
      if (mins >= 60) {
        hours += Math.floor(mins / 60);
        mins = mins % 60;
      }
      this.fillHoursAndMinsOptions(hours, 1440, true);
      endTime = moment(startTime, 'MMM DD, YYYY, hh:mm A').add(hours, 'hours').add(mins, 'minutes').format('MMM DD, YYYY, hh:mm A');
    }
    this.setState({
      start: startTime,
      end: endTime,
      slotId: data.slot_id ? data.slot_id : this.state.slotId,
      isStartTimeForGatedCalled: startTime ? true : false,
      gatedDurationHrs: hours,
      gatedDurationMins: mins,
      showDateTimeModal: false,
      isGatedTimeFetched,
      fields: {
        ...this.state.fields,
        ...{
          hours: hours >= 0 ? hours : this.state.fields.hours,
          mins: mins >= 0 ? mins : this.state.fields.mins
        }
      }
    }, () => {
      if(!startTime) toast.error('Cannot get booking start time');
      if(startTime) this.calculatePrice(isCallValidateCoupon);
    })
  }

  handleInitQRScan(value){
    if(value) window.scrollTo(0,0);
    this.setState({
      isQRScan: value
    })
  }

  handleQRScanError = () => {
    this.setState({
      isQRScan: false
    }, () => {
      toast.error('Invalid QR Scan');
      this.stopScanResult = false;
    })
  }

  handleQRCodeScanResult = (result, error) => {
    if (result && result.text) {
      if(this.stopScanResult) return;
      this.stopScanResult = true;
      let campaign;
      if(result.text) {
        try {
          campaign = JSON.parse(result.text);
        } catch(e) {
          this.handleQRScanError(campaign);
          return;
        }
      }else{
        this.handleQRScanError(campaign);
        return;
      }
      if(!campaign || !campaign.token){
        this.handleQRScanError(campaign);
        return;
      }
      this.setState({loading: true, isQRScan: false});
      fetch(`${this.baseUrl}/parking/campaign/coupon?parking_id=${this.state.parkingId}&coupon_code=${campaign.token}&is_valet=false&web_log_id=${this.logId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.coupon_code){
            this.setState({
              isQRScan: false,
              fields:{
                ...this.state.fields,
                coupon: this.removeSpace(resp.data.coupon_code) 
              }
            }, () => {
              this.stopScanResult = false;
              this.validateCoupon();
            })
          }else{
              this.setState({loading: false});
              this.stopScanResult = false;
              toast.error('Something went wrong');
          }
        })
        .catch((error) => {
           this.setState({loading: false});
            this.stopScanResult = false;
            toast.error('Something went wrong');
        });
    }

    if (error) {
    }
  }

  validateCoupon(isURLCoupon){
    let couponApplyBtn = document.querySelector('.coupon-apply') || {};
    couponApplyBtn.disabled = true;
    if(this.state.couponApplied){
      this.calculatePrice();
      couponApplyBtn.disabled = false;
      return;
    }
    let {start, end, parkingFee, convenienceFee, totalFee, parkingId, fields} = this.state;
    const condition1 = !start || !end || !parkingFee || !convenienceFee || !totalFee || !parkingId || !fields.coupon;
    const condition2 = !start || !end || !parkingId || !fields.coupon;
    const dynamicCondition = isURLCoupon ? condition2 : condition1;
    if(dynamicCondition){
      couponApplyBtn.disabled = false;
      return;
    } 

    this.setState({loading : true });
    const startDateTime = moment(start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const endDateTime = moment(end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    let request = {
      "start_date_time": startDateTime,
      "end_date_time": endDateTime,
      "coupon_code": this.removeSpace(this.state.fields['coupon']),
      "parking_charge": totalFee,
      "parking_fee": parkingFee,
      "convenience_fee": convenienceFee,
      "parking_id": parkingId,
      "web_log_id": this.logId
    };
    fetch(`${this.baseUrl}/coupons`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.coupon_detail){
            const hasKeys = !!Object.keys(resp.data.coupon_detail).length;
            if(hasKeys){
              let appendEnd = {end};
              let cd = resp.data.coupon_detail;
              if(isURLCoupon && (startDateTime == endDateTime)){
                appendEnd.end = moment(end, 'MMM DD, YYYY, hh:mm A').add(1, 'seconds');
              }
              this.setState({
                couponApplied: true,
                parkingFee: cd.parking_fee,
                convenienceFee: cd.convenience_fee,
                totalFee: cd.payable_amount,
                discountAmount: cd.discount_amount,
                salesTaxFee: cd.sales_tax_fee,
                surchargeFee: cd.surcharge_fee,
                transactionFee: cd.additional_transaction_fee,
                loading: false,
                isPayment: cd.payable_amount > 0 ? true : false,
                hideCouponAndDurationAndTiming: isURLCoupon ? true : false,
                couponBookingDuration: cd.payable_amount <= 0 && cd.coupon_booking_duration ? cd.coupon_booking_duration : false,
                ...appendEnd
              }, () =>  couponApplyBtn.disabled = false)
            }else{
              this.setState({loading : false});
              toast.dismiss();
              toast.error('Invalid coupon');
              couponApplyBtn.disabled = false;
            }
          }else{
            let fields = this.state.fields;
            fields["coupon"] = '';
            this.setState({
              couponApplied: false,
              discountAmount: 0,
              fields,
              loading: false
            }, () =>  couponApplyBtn.disabled = false)  
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            toast.dismiss();
            toast.error(errMsg, { autoClose: resp.error && resp.error.reason ? 10000 : 2000 });
          }
        })
        .catch((error) => {
          this.setState({loading : false}, () =>  couponApplyBtn.disabled = false)
          toast.dismiss();
          toast.error('Something went wrong');
        });
  }

  calculatePrice(isCallValidateCoupon){
    const start = moment(this.state.start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const end = moment(this.state.end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const spotNo = this.state.fields['spot_no'];
    if(!start || !end || (!spotNo && this.state.isWithSlot)) return;
    fetch(`${this.baseUrl}/pay/parking/slot/details?start_date_time=${start}&end_date_time=${end}&parking_id=${this.state.parkingId}&slot_name=${spotNo && spotNo.length === 1 ? '0' + spotNo : spotNo ? spotNo : ''}&slot_id=${!this.state.isWithSlot ? this.state.fixedSlotId : null}&web_log_id=${this.logId}`)
        .then(response => response.json())
        .then(resp => {
          if(resp.data && resp.status === "SUCCESS"){
                let fields = this.state.fields;
                fields["coupon"] = isCallValidateCoupon ? fields["coupon"] : '';
                this.setState({ 
                  slotId: this.state.isStartTimeForGatedCalled && this.state.slotId ? this.state.slotId : this.state.isWithSlot ? resp.data.slot_id : this.state.fixedSlotId,
                  parkingFee: resp.data.parking_fee,
                  convenienceFee: resp.data.convenience_fee,
                  totalFee: resp.data.parking_charge,
                  showWarning: resp.data.restricted_message ? true : false,
                  warningMsg: resp.data.restricted_message ? resp.data.restricted_message : '',
                  parkingType: resp.data.parking_type,
                  couponApplied: false,
                  hideCouponAndDurationAndTiming: isCallValidateCoupon ? true : false,
                  discountAmount: 0,
                  salesTaxFee: resp.data.sales_tax_fee,
                  surchargeFee: resp.data.surcharge_fee,
                  transactionFee: resp.data.additional_transaction_fee,
                  fields,
                  isPayment: resp.data.parking_charge > 0 ? true : false
                }, () => {
                  if(isCallValidateCoupon){
                    this.validateCoupon(true);
                  }
                })  
          }else{
            let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
            let fields = this.state.fields;
            fields["coupon"] = '';
            fields["spot_no"] = ''; 
            this.setState({
              fields,
              parkingFee: null,
              convenienceFee: null,
              totalFee: null,
              couponApplied: false,
              salesTaxFee: null,
              surchargeFee: null,
              transactionFee: null,
              discountAmount: 0
            }, () => {
              toast.dismiss();
              toast.error(errMsg, {autoClose: 2000});
            })
          }
        })
        .catch((error) => {
          toast.dismiss();
          toast.error('Something went wrong');
        });
   }

  getLotTZ(id){
    let timeZone = '';
    switch (id) {
      // san antonio
      case 5705:
        timeZone = 'US/Central';
        break;
      // miami  
      case 5706:
      case 5707:  
        timeZone = 'US/Eastern';
        break;
      default:
        break;
    }
    return timeZone;
  }

  handleAreaCode(areaCode){
    let fields = {...this.state.fields};
    fields['areaCode'] = areaCode;
    this.setState({ 
      fields 
    });
  }

  debounce(func, timeout = 10){
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => { 
        func.apply(this, args);
      }, timeout);
    };
  }

  handleSpotChange(e){
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value ? e.target.value.trim() : '';
    const isInValid = !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(fields[e.target.name]);
    if(!isInValid) return;
     
    this.setState({
        fields,
        isTimingDisabled: fields[e.target.name].length ? false : true
      }, () => {
        if((this.state.fields['hours'] || this.state.fields['mins']) && this.state.fields['spot_no'] && this.state.fields['spot_no'].length){
          /* const processChange = this.debounce(() => this.calculatePrice());
          processChange(); */
          let duration = 1000;
          clearTimeout(this.inputTimer);
          this.inputTimer = setTimeout(()=>{
            this.calculatePrice();
          }, duration);  
        }
    });
  }

  handleChange(e) {
    if(!this.state.fields.spot_no && this.state.isWithSlot && this.state.isGatedCamera && e.target.name === 'license_plate'){
      toast.error('Please enter spot number first');
      document.querySelector("#spot_no").focus();
      document.querySelector("#elem_license_plate").value = '';
      return;
    }
    let fields = {...this.state.fields};
    fields[e.target.name] = e.target.value;
    if(e.target.name === 'hours' || e.target.name === 'mins'){
      let selectedMins = e.target.name === 'mins' ? e.target.value : this.state.fields.mins;
      let selectedHours = e.target.name === 'hours' ? e.target.value : this.state.fields.hours;

      if (parseInt(selectedHours) > 23) {
        selectedMins = 0;
      }

      if(this.state.isGatedCamera && this.state.isGatedTimeFetched && e.target.name === 'hours'){
        if(parseInt(selectedHours) === this.hours[0].value){
          selectedMins = this.state.gatedDurationMins.toString();
        }else{
          selectedMins = "0";
        }
      }

      if(parseInt(selectedHours) === this.hours[0].value && parseInt(selectedMins) < this.state.gatedDurationMins){
        toast.error(`The duration cannot be less than ${this.state.gatedDurationHrs}hr ${this.state.gatedDurationMins}min`);
        return;
      }
      if (e.target.name === 'hours') {
        fields.hours = selectedHours;
        fields.mins = selectedMins;
      } else {
        fields.mins = selectedMins;
      }
      this.setState({
        fields
      }, () => {
        this.setState({
          end: moment(this.state.start, 'MMM DD, YYYY, hh:mm A').add(this.state.fields['hours'], 'hours').add(this.state.fields['mins'], 'minutes').format('MMM DD, YYYY, hh:mm A')
        }, () => { if((this.state.fields['spot_no'] && this.state.fields['spot_no'].length) || !this.state.isWithSlot) this.calculatePrice()});
      });
    }else if(e.target.name === 'license_plate'){
      this.setState({
        fields,
        license_plate_char_err:  this.nonSpecialCharacterForValue(e.target.value) ? 'special characters are not allowed' : '',
        isStartTimeForGatedCalled: false
      })
      return;
    }else{
      this.setState({
        fields
      });
    }
  }

  nonSpecialCharacter(name){
    let fields = this.state.fields;
    return !/[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(fields[name]);
  }

  nonSpecialCharacterForValue(value){
   return /[!@#$%^&*()\-_=+\[\]{}|;:'",<.>/?]/g.test(value);
  }

  onlyZip(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]{5}$/)){
      return false;
    }
    return true;
  }

  onlyPhone(name){
    let fields = this.state.fields;
    if(!fields[name].match(/^[0-9]*$/)){
      return false;
    }
    return true;
  }

  onlyEmail(name){
    let fields = this.state.fields;
    if(!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(fields[name])){
      return false;
    }
    return true;
  }

  initForm(){
    this.getArena();
    this.stripe = window.Stripe(this.stripeKey);
    var elements = this.stripe.elements();

    var style = {
      base: {
        iconColor: '#666EE8',
        color: '#000',
        lineHeight: '40px',
        fontSize: '16px',
    
        '::placeholder': {
          color: '#000',
          fontWeight: 300,
          fontSize: '13px'
        },
      },
    };

    this.paymentRequest = this.stripe.paymentRequest({
      country: 'US',
      currency: 'usd',
      total: {
        label: '',
        amount: this.state.totalFee ? this.state.totalFee : 0
      },
      requestPayerName: true
    });

    var elements = this.stripe.elements();
    this.payRequestButton = elements.create('paymentRequestButton', {
      paymentRequest: this.paymentRequest
    });

    
    this.paymentRequest.canMakePayment().then((result) => {
      this.checkIfAppleGooglePayOption(result);
    });

    this.payRequestButton.on('click', (event) => {
      this.handlePayRequestButtonClick(event);
    });

    this.paymentRequest.on('paymentmethod', (ev) => {
      clearTimeout(this.enableAppleGooglePayButtonTimeout);
      this.onPaymentRequestStart(ev);
    });

    this.paymentRequest.on('cancel', () => {
      clearTimeout(this.enableAppleGooglePayButtonTimeout);
      this.isAppleGooglePayButtonClicked = false;
    });
    
    this.card = elements.create('card', {style: style, hidePostalCode: false});

    this.card.mount('#card-element');

    this.card.addEventListener('change', function(event) {
      var displayError = document.getElementById('card-errors');
      if (event.error) {
        displayError.textContent = event.error.message;
      } else {
        displayError.textContent = '';
      }
    });
  }

  checkIfAppleGooglePayOption(result){
    if (result) {
      this.setState({
        walletType: result.applePay ? 'applePay' : result.googlePay ? 'googlePay' : ''
      },() => {
        document.getElementById('partners-button').style.display = 'block';
        this.payRequestButton.mount('#payment-request-button');
      })
     
    } else {
      document.getElementById('payment-request-button').style.display = 'none';
    }
  }

  handlePayRequestButtonClick(event){
    if (this.fetchingGatedTime || this.isAppleGooglePayButtonClicked) {
      event.preventDefault();
      return;
    }
    this.isAppleGooglePayButtonClicked = true;
    if(this.state.isPaymentProcessing) return;
    const isValid = this.validateForm(false);
    if(!isValid) {
      event.preventDefault();
      this.isAppleGooglePayButtonClicked = false;
      return;
    }
    this.enableAppleGooglePayButtonTimeout = setTimeout(() => {
      this.isAppleGooglePayButtonClicked = false;
    }, 15000);
    try{
      this.paymentRequest.update({
        total: {
          label: '',
          amount: this.state.totalFee,
        }
      });
    }catch(e) {
      console.log(e);
    }
  }

  onPaymentRequestStart(ev){
    let payErrorMsg = '';
    let request = this.prepareRequest('', ev.paymentMethod.id, '', '', '',  this.state.walletType);
    delete request.payment_details;
    fetch(`${this.baseUrl}/parking/payment/authenticate`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
      })
    .then(response => response.json())
    .then(resp => {
        if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded'){
          this.handleSubmit('', '', ev.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id, ev, this.state.walletType);
        }else if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action'){
          this.stripe
              .confirmCardPayment(resp.data.client_secret)
              .then((ccp) => {
                if(ccp.error){
                  ev.complete('fail');
                  payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                  payErrorMsg = getStripeError(payErrorMsg);
                  this.openErrorModal(payErrorMsg);
                  this.isAppleGooglePayButtonClicked = false;
                }else{
                  this.handleSubmit('', '', ev.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id, ev, this.state.walletType);
                }
              });
        }else{
          ev.complete('fail');
          payErrorMsg = getStripeError('');
          this.openErrorModal(payErrorMsg);
          this.isAppleGooglePayButtonClicked = false;
        }
      })
      .catch((error) => {
        ev.complete('fail');
        payErrorMsg = getStripeError('');
        this.openErrorModal(payErrorMsg);
        this.isAppleGooglePayButtonClicked = false;
    });
  }

  removeSpace(str){
    return str.replace(/\s+/g, '');
  }

  openErrorModal(payErrorMsg){
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.manageBodyBackground(true);
    this.setState({payErrorMsg});
  }

  setOutcome(result, req) {
    let payErrorMsg = '';
    const submitBtn = document.getElementById("pay-submit");
    if (result && result.paymentMethod && result.paymentMethod.id) {
      let request = this.prepareRequest('', result.paymentMethod.id);
      fetch(`${this.baseUrl}/parking/payment/authenticate`, {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify(request)
       })
      .then(response => response.json())
      .then(resp => {
          if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'succeeded'){
            this.handleSubmit('', this.card, result.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id)
          }else if(resp.data && resp.status === "SUCCESS" && resp.data.status === 'requires_action'){
            this.stripe
              .confirmCardPayment(resp.data.client_secret, {
                payment_method: req
              })
              .then((ccp) => {
                if(ccp.error){
                  this.manageBodyBackground(false);
                  this.setState({isPaymentProcessing : false});
                  payErrorMsg = ccp && ccp.error && ccp.error.message ? ccp.error.message : 'Something went wrong';
                  payErrorMsg = getStripeError(payErrorMsg);
                  this.openErrorModal(payErrorMsg);
                  submitBtn.disabled = false;
                }else{
                  this.handleSubmit('', this.card, result.paymentMethod.id, resp.data.customer, resp.data.payment_intent, resp.data.charge_id)
                }
              });
          }else{
            this.manageBodyBackground(false);
            this.setState({isPaymentProcessing : false});
            payErrorMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong';
            payErrorMsg = getStripeError(payErrorMsg);
            this.openErrorModal(payErrorMsg);
            submitBtn.disabled = false;
          }
        })
        .catch((error) => {
          this.manageBodyBackground(false);
          this.setState({isPaymentProcessing : false});
          payErrorMsg = getStripeError('');
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
      });
    } else if (result.error) {
      this.manageBodyBackground(false);
      this.setState({isPaymentProcessing : false});
      payErrorMsg = result.error.message ? result.error.message : 'Something went wrong';
      payErrorMsg = getStripeError(payErrorMsg);
      this.openErrorModal(payErrorMsg);
      submitBtn.disabled = false;
    }
  }

  validateForm(isCard){
    let fields = this.state.fields;
    let formIsValid = true;
    this.errors = {};
    const isURLCouponApplied = this.state.isURLCoupon && this.state.couponApplied;
    const cardWrapper = document.querySelector('#card-element');
    const cardWrapperError = document.querySelector('#card-errors');
   let isPayment = this.state.isPayment;
    if (this.state.isWithSlot && (!fields["spot_no"] || (fields["spot_no"] && fields["spot_no"].trim() === ''))) {
      formIsValid = false;
      this.errors["spot_no"] = "enter a spot no.";
    }
    if (!fields["license_plate"] || (fields["license_plate"] && fields["license_plate"].trim() === '')) {
      formIsValid = false;
      this.errors["license_plate"] = "enter your license plate no.";
    }
    if (typeof fields["license_plate"] !== "undefined") {
      const isValid = this.nonSpecialCharacter("license_plate");
      if (!isValid) {
        formIsValid = false;
        this.errors["license_plate"] = "special characters are not allowed";
      }
    }
    if (!fields["mobile"] || (fields["mobile"] && fields["mobile"].trim() === '')) {
      formIsValid = false;
      this.errors["mobile"] = "enter your mobile no.";
    }
    if (typeof fields["mobile"] !== "undefined") {
      const isValid = this.onlyPhone("mobile");
      if (!isValid) {
        formIsValid = false;
        this.errors["mobile"] = "enter a valid mobile no.";
      }
    }

    if (fields["email"] != '' && fields["email"].trim() != '') {
      const isValid = this.onlyEmail("email");
      if (!isValid) {
        formIsValid = false;
        this.errors["email"] = "enter a valid email address";
      }
    }

    if (!isURLCouponApplied && (!fields["hours"] || fields["hours"] == 0) && (!fields["mins"] || fields["mins"] == 0)) {
      formIsValid = false;
      this.errors["duration"] = "select the parking duration";
    }
    if(isCard && isPayment){
      if(cardWrapper.classList.contains('StripeElement--empty')){
        formIsValid = false;
        cardWrapperError.innerHTML = "enter your card number";
      }
      if(cardWrapper.classList.contains('StripeElement--invalid')){
        formIsValid = false;
        if(!cardWrapperError.innerHTML.trim()) cardWrapperError.innerHTML = "enter valid details";
      }
      if (!fields["cardholder_name"] || (fields["cardholder_name"] && fields["cardholder_name"].trim() === '')) {
        formIsValid = false;
        this.errors["cardholder_name"] = "enter the cardholder name";
      }
    }else if(cardWrapperError && this.card){
      cardWrapperError.innerHTML = "";
      this.card.clear();
    }
    this.setState({
      errors: this.errors
    });
    return formIsValid;
  }

  prepareRequest(id, paymentMethodId, customerId, paymentIntent, chargeId, walletType, isWithoutPayment){
    const { fields, couponApplied } = this.state;
    const countryCodeName = countryCode.filter(item => item.id == fields.areaCode)[0]; 
    const start = moment(this.state.start, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const end = moment(this.state.end, 'MMM DD, YYYY, hh:mm A').unix() * 1000;
    const request = {
      apple_pay: walletType === 'applePay' ? true : false,
      google_pay: walletType === 'googlePay' ? true : false,
      source_id: id ? id : '',
      email: fields.email ? fields.email.trim() : '',
      contact_number: fields.mobile ? fields.mobile.trim() : '',
      country_code: fields.areaCode ? '+' + fields.areaCode : '',
      country_name: countryCodeName ? countryCodeName.name : '',
      vehicle_no: fields.license_plate ? fields.license_plate.toUpperCase().replace(/\s/g, "").replace(/\\/g, '') : '',
      start_date_time: start,
      end_date_time: end,
      parking_arena_id: this.state.parkingId,
      slot_id: this.state.isGatedCamera ? this.state.slotId : this.state.isWithSlot ? this.state.slotId : this.state.fixedSlotId,
      cardholder_name: fields["cardholder_name"] ? fields["cardholder_name"] : '',
      save_profile: this.state.isSaveProfile,
      coupon_code: couponApplied && fields.coupon ? this.removeSpace(fields.coupon) : '',
      payment_method_id: paymentMethodId ? paymentMethodId : '',
      payment_details: { 
        customer: customerId ? customerId : '',
        payment_intent: paymentIntent ? paymentIntent : '',
        charge_id: chargeId ? chargeId : ''
      },
      web_log_id: this.logId
    }
    if(isWithoutPayment){
      delete request.payment_method_id;
      delete request.payment_details;
    }
    return request;
  }

  preSubmit(){
    if(this.fetchingGatedTime) return;
    document.getElementById("pay-submit").disabled =  true;
    if(this.state.isPaymentProcessing) return;
    const submitBtn = document.getElementById("pay-submit");
    const isValid = this.validateForm(true);
    if(!isValid) {
      submitBtn.disabled = false;
      return;
    }
   let isPayment = this.state.isPayment;
    this.manageBodyBackground(true);
    this.setState({isPaymentProcessing : true});
    if(isPayment){
      const { fields } = this.state;
      let contactNumber = fields.mobile ? fields.mobile.trim() : '';
      let countryCode = fields.areaCode ? '+' + fields.areaCode : '';
      var options = {
        name: fields.cardholder_name,
        phone: countryCode +' '+ contactNumber
      };
      if(fields.email){
        options.email = fields.email ? fields.email.trim() : ''
      }
      let req = {
        type: 'card',
        card: this.card,
        billing_details: {
          name: fields.cardholder_name,
          phone: countryCode +' '+ contactNumber
        }
      }
      this.stripe.createPaymentMethod(req).then((result) => this.setOutcome(result, req));
    }else{
      const isWithoutPayment = !isPayment;
      this.handleSubmit('', this.card, false, false, false, false, false, '', isWithoutPayment);
    }
  }

  handleSubmit(id, card, paymentMethodId, customerId, paymentIntent, chargeId, btnEvent, walletType, isWithoutPayment){
    let payErrorMsg = '';
    const submitBtn = document.getElementById("pay-submit");
    let request = this.prepareRequest(id, paymentMethodId, customerId, paymentIntent, chargeId, walletType, isWithoutPayment);
    fetch(`${this.baseUrl}/pay/parking/reserve`, {
      method: 'post',
      headers: {'Content-Type':'application/json'},
      body: JSON.stringify(request)
     })
      .then(response => response.json())
      .then(resp => {
        if(resp.data && resp.status === "SUCCESS"){
          window.scrollTo(0,0);
          this.setState({...this.resetState, bookingID: resp.data.booking_id, hash: resp.data.hash}, () => {
            if(card) card.clear();
            this.getArena();
            submitBtn.disabled = false;
            this.isAppleGooglePayButtonClicked = false;
            if(btnEvent)  btnEvent.complete('success');
            setTimeout(() => {
              this.redirectToView(this.state.hash);
            }, 2000);
          });
        }else{
          let errMsg = resp.error && resp.error.reason ? resp.error.reason : 'Something went wrong'; 
          if(btnEvent)  btnEvent.complete('fail');
          this.manageBodyBackground(false);
          this.setState({isPaymentProcessing : false});
          payErrorMsg = getStripeError(errMsg);
          this.openErrorModal(payErrorMsg);
          submitBtn.disabled = false;
          this.isAppleGooglePayButtonClicked = false;
        }
      })
      .catch((error) => {
        if(btnEvent)  btnEvent.complete('fail');
        this.manageBodyBackground(false);
        this.setState({isPaymentProcessing : false});
        payErrorMsg = getStripeError('');
        this.openErrorModal(payErrorMsg);
        submitBtn.disabled = false;
        this.isAppleGooglePayButtonClicked = false;
      });  
  }

  redirectToView = (hash) => {
    if(hash){
      const currentUrl = window.location.origin;
      let newUrl = `${currentUrl}/view?hash=${hash}`;
      if(this.isDev){
        newUrl += '&env=dev';
      }
      window.location.href = newUrl;
    }
  }

  find(search, keys){
    if(!search) {
      return {
        "id": "1",
        "name": "US",
        "displayText": "United States (+1)",
        "country": "United States",
        "locale": "",
        "flag": `${URL.S3_BUCKET2}/FlagKit/US.imageset/US.png`
      }
    }
    var lowSearch = search.toLowerCase();
    return countryCode.filter(function(item){
        return keys.some( key => 
            String(item[key]).toLowerCase().includes(lowSearch) 
        );
    });
  }

  handleFocus(name){
    document.querySelector(`input[name="${name}"]`).focus();
    return false;
  }

  handleFocusSp(name){
    document.querySelector(`select[name="${name}"]`).focus();
    return false;
  }

  handleClose(){
    this.setState({booked: false, bookedID: null }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleErrorModalClose(){
    this.setState({payErrorMsg: false }, () => {
      this.manageBodyBackground(false);
    })
  }

  handleProfile(){
    this.setState({
      isSaveProfile: !this.state.isSaveProfile
    })
  }

  handleSeeMore(){
    this.setState({seeMore: !this.state.seeMore }, () => {
      this.manageBodyBackground(this.state.seeMore);
    })
  }

  handleEmptySlot(){
    if(!this.state.isTimingDisabled || !this.state.isWithSlot) return;
    toast.dismiss();
    toast.error('Please enter spot no.');
  }

  hideWarningModal(e, isClearSlot){
    if(isClearSlot){
      let fields = this.state.fields;
      fields["spot_no"] = ''; 
      this.setState({
        slotId: '',
        fields,
        showWarning: false,
        warningMsg: '',
        parkingFee: '',
        convenienceFee: '',
        totalFee: '',
        parkingType: ''
      })
    }else{
      this.setState({
        showWarning: false,
        warningMsg: ''
      })
    }
  }

  hideInvalidURLModal = () => {
    this.setState({
      isInvalidURL: false,
      showOverlay: true
    })
  }

  calculateNetAmount(){
    const parkingFee = this.state.parkingFee || 0;
    const salesTaxFee = this.state.salesTaxFee || 0;
    const surchargeFee = this.state.surchargeFee || 0;
    const discountAmount = this.state.discountAmount || 0;
    let net = (parkingFee + salesTaxFee + surchargeFee) - discountAmount;
    if(net < 0) net = 0;
    return `$${(net/100).toFixed(2)}`;
  }

  calculateConvenienceFee(){
    const convenienceFee = this.state.convenienceFee || 0;
    const transactionFee = this.state.transactionFee || 0;
    let conv = convenienceFee + transactionFee;
    if(conv < 0) conv = 0;
    return `$${(conv/100).toFixed(2)}`;
  }

  removeSecondBrackets(input) {
    if (!input) {
        return input;
    }
    const regex = /(.*?\(.*?\))(.*?\(.*?\))/;
    const result = input.replace(regex, '$1');
    return result;
  }

  render() {
   let isPayment = this.state.isPayment;
    const showStartTimeEdit = this.state.start && this.state.isStartTimeEmpty;
    return (
      <div style={{position: 'relative'}}>
        {(this.state.loading || this.state.isPaymentProcessing  || this.state.payErrorMsg || this.state.showErrorModal || this.state.isInvalidURL || this.state.showOverlay) && <div className='loader-background'></div>}
        {this.state.loading && <div className="loader">Loading...</div>}
        {this.state.isPaymentProcessing && 
          <div className="loader-v2">
            <div className='spinner'></div>
            <p>Please do not refresh this page or press back button while we are processing your payment.</p>
          </div>}
        <div style={{display: this.state.vehicleCategory ? 'block' : 'none'}} className="success-message">
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Valid Booking</h3>
          <div className="success-message__content">
              <p style={{color: '#333'}}>{`This is a ${this.state.vehicleCategory} vehicle — booking not required.`}</p>
          </div>
        </div>
        <div style={{display: this.state.booked ? 'block' : 'none'}} className="success-message">
          <span onClick={this.handleClose.bind(this)} id="sm-close">&times;</span>
          <svg viewBox="0 0 76 76" className="success-message__icon icon-checkmark">
            <circle cx="38" cy="38" r="36"></circle>
            <path fill="none" stroke="#FFFFFF" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="M17.7,40.9l10.9,10.9l28.7-28.7" style={{strokeDashoffset: 0, strokeDasharray: 56.0029}}></path>
          </svg>
          <h3 className="success-message__title">Booked Successfully</h3>
          <div className="success-message__content">
              <p>Booking Id: {this.state.bookingID}</p>
          </div>
        </div>
        
        <div style={{display: this.state.showWarning ? 'block' : 'none'}} className="success-message">
          {this.state.parkingType === 'restricted' && <span onClick={this.hideWarningModal.bind(this, true)} id="sm-close">&times;</span>} 
          <div style={{textAlign: 'center'}}>
            <img style={{height: 55}} src={notAllowed} /> 
          </div>
          <h4 style={{color: '#000'}} className="success-message__title">{this.state.warningMsg}</h4>
          {this.state.parkingType === 'limited' && <div style={{transform: `translateY(35px)`}}>
            <button style={{marginRight: '25px'}} className="limited-rule-btn1" onClick={this.hideWarningModal.bind(this)}>Proceed</button>
            <button className="limited-rule-btn2" onClick={this.hideWarningModal.bind(this, true)}>Cancel</button>
          </div>}
        </div>

        <div style={{display: this.state.isInvalidURL ? 'block' : 'none'}} className="success-message">
         <span onClick={this.hideInvalidURLModal} id="sm-close">&times;</span>
          <div style={{textAlign: 'center'}}>
            <img style={{height: 55}} src={notAllowed} /> 
          </div>
          <h4 style={{color: '#333'}} className="success-message__title">This is a sample page. To pay for parking at your location, please scan the QR code or text the Text to Pay code to the number provided on the signs at the location.</h4>
        </div>

        <div style={{display: this.state.payErrorMsg ? 'block' : 'none'}} className="error-message">
          <span onClick={this.handleErrorModalClose.bind(this)} id="sm-close">&times;</span>
          <svg fill="#FF0000" viewBox="0 0 478.125 478.125" xmlSpace="preserve" className="error-message__icon icon-checkmark">
            <g>
              <g>
                <g>
                  <circle cx="239.904" cy="314.721" r="35.878" />
                  <path d="M256.657,127.525h-31.9c-10.557,0-19.125,8.645-19.125,19.125v101.975c0,10.48,8.645,19.125,19.125,19.125h31.9
                  c10.48,0,19.125-8.645,19.125-19.125V146.65C275.782,136.17,267.138,127.525,256.657,127.525z" />
                  <path d="M239.062,0C106.947,0,0,106.947,0,239.062s106.947,239.062,239.062,239.062c132.115,0,239.062-106.947,239.062-239.062
                  S371.178,0,239.062,0z M239.292,409.734c-94.171,0-170.595-76.348-170.595-170.596c0-94.248,76.347-170.595,170.595-170.595
                  s170.595,76.347,170.595,170.595C409.887,333.387,333.464,409.734,239.292,409.734z" />
                </g>
              </g>
            </g>
          </svg>
          <div className="error-message__content">
             <p>{this.state.payErrorMsg}</p>
          </div>
        </div>

        {this.state.showErrorModal && <ErrorModal/>}
        {this.state.seeMore && this.state.arenaDetails && <div className="lot-details">
          <span onClick={this.handleSeeMore.bind(this)} id="sm-close">&times;</span>
          <LotDetails details={this.state.arenaDetails} />
        </div>}
        <form style={{pointerEvents: this.state.booked || this.state.seeMore ? 'none' : 'auto'}} action="#" method="POST">
          <input type="hidden" name="token" />
          <div style={{textAlign: 'center', paddingBottom: 20}}>
            <img style={{height: 85}} src="https://portal.parkquility.com/public/pq_logo.png" />
          </div>
          <div style={{textAlign: 'center'}} className="location">
            <img style={{height: 35}} src={gpsIcon} /> 
            <span>{this.state.name}</span>
          </div>
          {this.state.isWithSlot && <div className="upper">
            <span onClick={() => this.handleFocus('spot_no')}>To get started, please tell us the spot no. you are parked on  <i>*</i></span>
            <input
              id="spot_no"
              className="pay-fields" 
              value={this.state.fields["spot_no"]}
              style={{textTransform: 'uppercase'}}
              name="spot_no"
              onChange={this.handleSpotChange}
              maxLength={4}
            />
            <div className="error-msg">{this.state.errors['spot_no']}</div>
          </div>}
          <div className="upper">
            <span onClick={() => this.handleFocus('license_plate')}>{this.state.isWithSlot ? 'Now, give us the license plate no.' :  'To get started, please tell us the license plate no.'} (No State Code) <i>*</i></span>
            <input
              className="pay-fields" 
              style={{textTransform: 'uppercase'}}
              id="elem_license_plate"
              value={this.state.fields["license_plate"]}
              name="license_plate"
              onChange={this.handleChange}
              maxLength={10}
              onBlur={this.handleGatedContactNumberFocus.bind(this)}
            />
            <div style={{fontSize: '12px', color: '#afafaf', maxWidth: '406px'}}>{this.state.isShowOversizeMsg ? <>Inaccurate License Plate number will result in  monetary fine.<br/> Oversized vehicles not allowed. Can be towed at owner's risk and expense.</> : "Inaccurate License Plate number will result in  monetary fine."}</div>
            <div className="error-msg">{this.state.errors['license_plate'] ? this.state.errors['license_plate'] : this.state.license_plate_char_err}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('email')}>Next, provide your email address. We will send you the receipt.</span>
            <input
              className="pay-fields" 
              value={this.state.fields["email"]}
              name="email"
              onChange={this.handleChange}
              maxLength={150}
            />
            <div className="error-msg">{this.state.errors['email']}</div>
          </div>
          <div className="upper">
            <span onClick={() => this.handleFocus('mobile')}>Enter your mobile no. to get updates <i>*</i></span>
            <div className="country-with-phone">
              <div className="country-code">
                  <ReactCustomFlagSelect
                    showSearch={false} 
                    showArrow={true} 
                    animate={true} 
                    value={this.state.fields['areaCode']}
                    customStyleOptionListContainer={{ maxHeight: '200px', overflow: 'auto', width: '240px', marginTop: '11px' }}
                    optionList={countryCode} 
                    onChange={areaCode => {
                      this.handleAreaCode(areaCode);
                    }}
                    
                  />
              </div>
              <div className="input-wrapper">
                  <input
                    className="pay-fields mobile-input" 
                    value={this.state.fields["mobile"]}
                    name="mobile"
                    onChange={this.handleChange}
                    maxLength={15}
                  />
              </div>
              <div style={{clear: 'both'}}></div>
            </div>
            <div style={{fontSize: '12px', color: '#000'}}>By entering your mobile no, you are giving us the consent to send you updates regarding this reservation via SMS.</div>
            <div className="error-msg">{this.state.errors['mobile']}</div>
          </div>
          {/* <div>
            <p style={{fontWeight: 500}}>If you visit this garage often, create an account for seamless experience</p>
            <a href="http://localhost:3000/customer-details?id=pqhrwj3x5n&mobile=+911234567890"><button type="button" className='sign-up'>Sign Up</button></a>
          </div> */}
          {this.state.couponBookingDuration ? <p style={{marginTop: '8px', fontWeight: 500}}>This reservation will be free for first <span style={{color: '#dc6e7d'}}>{this.state.couponBookingDuration} {this.state.couponBookingDuration > 1 ? 'hours.' : 'hour.'}</span></p> : ''}
          {!this.state.hideCouponAndDurationAndTiming && <div className="upper">
          {this.state.isGatedCamera ? <span onClick={() => this.handleFocusSp('hours')}>Your entry time {this.state.isStartTimeEmpty ? 'is' : 'has been recorded as'} {this.state.start}. Please select the duration you need parking for.<i>*</i></span> :<span onClick={() => this.handleFocusSp('hours')}>And lastly, select the duration you need this spot for <i>* </i></span>}
            {/* <input
              className="pay-fields" 
              value={this.state.fields["duration"]}
              name="duration"
              onChange={this.handleChange}
            /> */}
            <div className="pay-duration">
              <span onClick={this.handleEmptySlot.bind(this)}>
                <select disabled={this.state.isWithSlot && this.state.isTimingDisabled} name="hours" value={this.state.fields["hours"]} onChange={this.handleChange}>
                  {this.hours.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                </select>
              </span>
              {!this.state.isTypeEvent && <span onClick={this.handleEmptySlot.bind(this)}>
                <select 
                  disabled={((this.state.isWithSlot && this.state.isTimingDisabled) || (parseInt(this.state.fields.hours) > 23))}  
                  name="mins" 
                  value={this.state.fields["mins"]} 
                  onChange={this.handleChange} 
                  style={{marginLeft: '20px'}}>
                  {this.mins.map((item, index) => <option key={index} value={item.value}>{item.display}</option>)}
                </select>
              </span>}
              <div style={{clear: 'both'}}></div>
            </div>
            <div className="error-msg">{this.state.errors['duration']}</div>
          </div>}
          {this.state.parkingId == 5832 && <p>Garage gates closed between 11 PM to 6 AM.</p>}
          {!this.state.hideCouponAndDurationAndTiming && this.state.arenaDetails && <div style={{padding: '5px 0'}}>
            <span style={{color: 'rgb(220, 110, 125)', cursor: 'pointer'}} onClick={this.handleSeeMore.bind(this)}>See more</span>
          </div>}
          <h4 style={{paddingTop: 10, paddingBottom: 10}}>Reservation Summary</h4>
          <ul className="pay-timings">
            {!this.state.hideCouponAndDurationAndTiming && <>
            <li>
              <span className="list-initial">Start time</span>
              <span onClick={() => showStartTimeEdit ? this.handleDateTimeModal(true) : false}><div style={{borderBottom: showStartTimeEdit ? '2px solid #dc6e7d' : 'none', display: 'inline-block'}}>{this.state.start}</div> {showStartTimeEdit && window.innerWidth >= 418 && <button type="button" className="start-time-edit-btn">Edit</button>}</span>
            </li>
            <li>
              <span className="list-initial">End time</span>
              <span>{this.state.end}</span>
            </li>
            <li>
              <span className="list-initial">Parking fee</span>
              <span>{this.state.parkingFee > -1 ? `$${(this.state.parkingFee/100).toFixed(2)}` : ''}</span>
            </li>
            {this.state.discountAmount > 0 && <li>
              <span className="list-initial">Discount amount</span>
              <span>{this.state.parkingFee > -1 ? `$${(this.state.discountAmount/100).toFixed(2)}` : ''}</span>
            </li>}
            {this.state.surchargeFee > 0 && <li>
              <span className="list-initial">{this.removeSecondBrackets(this.state.surchargeFeeTitle)}</span>
              <span>{`$${(this.state.surchargeFee/100).toFixed(2)}`}</span>
            </li>}
            {this.state.salesTaxFee > 0 && <li>
              <span className="list-initial">{this.removeSecondBrackets(this.state.salesTaxFeeTitle)}</span>
              <span>{`$${(this.state.salesTaxFee/100).toFixed(2)}`}</span>
            </li>}
            <li>
              <span className="list-initial">Net amount</span>
              <span>{this.calculateNetAmount()}</span>
            </li>
            <li>
              <span className="list-initial">Convenience fee</span>
              <span>{this.calculateConvenienceFee()}</span>
            </li>
            </>}
            <li>
              <span className="list-initial">Total fee</span>
              <span style={{fontWeight: 600, fontSize: '18px'}}>{this.state.totalFee > -1 ? `$${(this.state.totalFee/100).toFixed(2)}` : ''}</span>
            </li>
          </ul>
          {!this.state.hideCouponAndDurationAndTiming && <div style={{position: 'relative'}} class="upper">
            <span onClick={() => this.handleFocus('coupon')} style={{fontWeight: 'bold', fontSize: '14px'}}>Apply Coupon</span>
            <div  className='apply-coupon-wrap' onClick={this.handleEmptySlot.bind(this)}>
              <input
                disabled={(this.state.isWithSlot && this.state.isTimingDisabled) || this.state.couponApplied}
                className="pay-fields" 
                value={this.state.fields["coupon"]}
                name="coupon"
                onChange={this.handleChange}
                maxLength={100}
                autoComplete='new-password'
                style={{paddingRight: '70px', fontSize: '16px', textTransform: 'uppercase'}}
              />
              {!this.isProd && this.state.isQRScanLot && <img src={cameraIcon} onClick={() => this.handleInitQRScan(true)} />}
            </div>
            {this.state.couponApplied && <div style={{color: 'green', fontSize: '11px', marginTop: '3px'}}>
               Coupon applied successfully!
            </div>}
            <button type="button" className={this.state.discountAmount ? 'coupon-apply c-a-blk' : 'coupon-apply'} onClick={() => this.validateCoupon()}>{this.state.discountAmount ? 'Remove' : 'Apply'}</button>
          </div>}
          <div style={{display: isPayment ? 'block' : 'none'}}>
            <h4 style={{paddingTop: 20, paddingBottom: 10}}>Payment</h4>
            <div style={{display: 'none'}} id='partners-button'>
              <div>
                <div style={{width: '150px'}}>
                <div id="payment-request-button"></div>
                </div>
              </div>
              <div class="separator">
                <div class="line"></div>
                <h6> or pay using your card </h6>
                <div class="line"></div>
              </div>
            </div>
            
            <div className="card-info">
              <div id="card-element">
              </div>
            </div>
            <div className="error-msg" id="card-errors" role="alert"></div>
            <div class="group">
              <label>
                <input onChange={this.handleChange} value={this.state.fields["cardholder_name"]} name="cardholder_name" class="field" placeholder="Cardholder name" />
              </label>
            </div>    
            <div style={{paddingLeft: '15px', marginTop: '4px'}} className="error-msg">{this.state.errors['cardholder_name']}</div> 
          </div>
          {this.env != 'PROD' && <div><label style={{fontSize: '13px'}} id="register" for="register-checkbox"><input onClick={this.handleProfile.bind(this)} checked={this.state.isSaveProfile} id="register-checkbox" name="register" type="checkbox" /> Save profile information for future bookings</label></div>}
          <p style={{paddingTop: '10px'}}>If you stay for more than 15 minutes after the expiration of your parking reservation, we may charge your card for the next time period.</p>
          <p style={{paddingTop: '10px'}}>There are no cancellations and refunds possible.</p>
          <button onClick={this.preSubmit.bind(this)} id="pay-submit" type="button">{isPayment ? 'Pay ' + (this.state.totalFee > 0 ? `$${(this.state.totalFee/100).toFixed(2)}` : '') : 'Make Reservation'}</button>
          <div style={{clear: 'both'}} />
          <p style={{padding: '10px 0'}}>For Extensions, Reservations, Assistance and Booking History, Download our App</p>
          <div className="download-app">
            <a target="_blank" href="https://apps.apple.com/in/app/parkquility/id1543951488"><img src={iosIcon} /></a>
            <a target="_blank" href="https://play.google.com/store/apps/details?id=com.parkquility"><img src={googleIcon} /></a>
            <div style={{clear: 'both'}}></div>
          </div>
          <div className="outcome">
            <div className="error" />
            <div className="success">
              Success! Your Stripe token is <span className="token" />
            </div>
          </div>
          <ToastContainer autoClose={2000} closeButton={true} style={{fontSize: 14}}/>
        </form>
        {this.state.isQRScan && <div className="qr-scan-popup">
          <img src={qrcode} />
          <span onClick={() => this.handleInitQRScan(false)} id="sm-close">&times;</span>
          <div>
            <QrReader
              constraints={{facingMode: 'environment'}}
              scanDelay={1000}
              onResult={(result, error) => this.handleQRCodeScanResult(result, error)}
              style={{ width: '100%' }}
            />
          </div>
        </div>}
        {this.state.showDateTimeModal && <DateTimeModal  submit={this.handleStartTimeForGated} start={this.state.start} close={this.handleDateTimeModal} />}
      </div>      
    )
  }
}
